import { Box, Card, CardContent, CircularProgress, Container, Divider, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useStore from '~/store';
import { container, containerForm, headerContainer } from './styles';

export default function HelpZipcodePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const { contractAsyncGetContext, contractAsyncGetContractByHashId, step, setCameFromEmail, contract_id } = useStore(
    (store) => ({
      contractAsyncGetContext: store.contractAsyncGetContext,
      contractAsyncGetContractByHashId: store.contractAsyncGetContractByHashId,
      setCameFromEmail: store.setCameFromEmail,
      step: store.step,
      contract_id: store.contract_id
    })
  );

  useEffect(() => {
    const fetchData = async () => {
      const contract_hash_id = searchParams.get('cid');
      const orgParam = searchParams.get('org');

      if (contract_hash_id) {
        try {
          await contractAsyncGetContractByHashId(contract_hash_id, orgParam ?? undefined);
        } catch (err: any) {
          console.error('Erro ao buscar contrato:', err);
          let errorMessage = 'Não foi possível recuperar os dados do contrato';
          if (err.isAxiosError) {
            const notifications = err.response?.data?.notifications;
            if (notifications) errorMessage = notifications[0]?.message;
          }
          setError(errorMessage);
        }
      } else {
        setError('Não foi possível recuperar os dados do contrato');
      }

      const source = searchParams.get('source');
      const intMod = searchParams.get('int_mod');
      if (source === 'email' && intMod === '1') {
        setCameFromEmail(true);
      }
    };

    fetchData();
  }, [searchParams]);

  useEffect(() => {
    if (contract_id) {
      const orgParam = searchParams.get('org');
      const fetchContext = async () => {
        try {
          await contractAsyncGetContext(contract_id, orgParam ?? undefined);
        } catch (err: any) {
          console.error('Erro ao buscar contexto:', err);
          let errorMessage = 'Não foi possível recuperar o contexto do contrato';
          if (err.isAxiosError) {
            const notifications = err.response?.data?.notifications;
            if (notifications) errorMessage = notifications[0]?.message;
          }
          setError(errorMessage);
        }
      };
      fetchContext();
    }
  }, [contract_id, searchParams]);
  useEffect(() => {
    if (step && step !== 'none') {
      const contract_hash_id = searchParams.get('cid');
      const source = searchParams.get('source');
      const orgParam = searchParams.get('org');

      const intMod = searchParams.get('int_mod');
      const buildUrl = (path: string) => {
        const params = new URLSearchParams();
        if (contract_hash_id) params.set('cid', contract_hash_id);
        if (source) params.set('source', source);
        if (orgParam) params.set('org', orgParam);
        if (intMod) params.set('int_mod', intMod);
        return `${path}?${params.toString()}`;
      };

      switch (step) {
        // case 'INSURED_INFORMATION':
        //   navigate('/contract/file')
        // break
        case 'INSURED_ADDRESS':
          console.log('Navegando para /contract/address');
          navigate(buildUrl('/contract/address'));
          break;
        case 'INSURED_ITEM':
          console.log('Navegando para /contract/equipment');
          navigate(buildUrl('/contract/equipment'));
          break;
        case 'INSURED_DOCUMENT':
          console.log('Navegando para /contract/file');
          navigate(buildUrl('/contract/file'));
          break;
        case 'INSURED_EMERGENCY_DATA':
          console.log('Navegando para /contract/emergency');
          navigate(buildUrl('/contract/emergency'));
          break;
        default:
          console.log('Navegando para /contract/user');
          navigate(buildUrl('/contract/user'));
          break;
      }
    }
  }, [step, searchParams]);
  return (
    <Container maxWidth="lg" sx={container}>
      <Grid container spacing={2}>
        <Grid item md={8} xs={12}>
          <Card>
            <CardContent>
              <Box sx={headerContainer}>
                <Typography variant="h6" align="center">
                  Dados para contrato
                </Typography>
              </Box>
              <Divider variant="middle" />
              <Box sx={containerForm}>
                {!error && (
                  <>
                    <CircularProgress />
                  </>
                )}
                {error && (
                  <>
                    <Typography>{error}</Typography>
                  </>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
